import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";

interface UnitUrgencyProps {
    available: number;
}

export const UnitUrgency = ({ available }: UnitUrgencyProps) => {
    const options = useDisplayOptionContext();

    if (!options.vacancyNotice || !options.vacancyThreshold) {
        return null;
    }

    return available <= options.vacancyThreshold && available > 0 ? (
        <span className="unit-item-urgency tw:font-bold">
            Hurry, only {available} left!
        </span>
    ) : null;
};